module.exports = __webpack_public_path__ + "img/eight4Red.7a6c0e38.jpg";